import type {SingleSelectAttrs} from '@jetbrains/ring-ui/components/select/select'
import Select from '@jetbrains/ring-ui/components/select/select'
import classNames from 'classnames'
import React, {useContext} from 'react'

import {DisabledContext} from '../../../../../contexts/DisabledContext'

import styles from './SidebarSelect.css'

type Props = SingleSelectAttrs & {
  containerClassName?: string
}

function SidebarSelect({className, selectedLabel, containerClassName, ...otherProps}: Props) {
  const isDisabled = useContext(DisabledContext)
  return (
    <div className={containerClassName}>
      <Select
        renderOptimization={false}
        {...otherProps}
        className={classNames(styles.select, className)}
        size={Select.Size.FULL}
        disabled={isDisabled}
      />
      {selectedLabel && <span className={styles.selectedLabel}>{selectedLabel}</span>}
    </div>
  )
}

export default SidebarSelect
